import { Injectable } from '@angular/core';

declare global {
  interface Window {
    setupEnforcement: (enf: any) => void;
    _arkoseEnforcement?: any;
    arkosePublicKey?: string;
  }
}

@Injectable({ providedIn: 'root' })
export class ArkoseService {

  private enforcement: any;
  private sdkReady: Promise<void>;
  private sdkReadyResolve!: () => void;
  private publicKey: string;

  private queue: Promise<any> = Promise.resolve();

  constructor() {
    this.publicKey = window.arkosePublicKey || '';
    console.log("Arkose Service initialized with key:", this.publicKey);

    this.sdkReady = new Promise<void>((resolve) => {
      this.sdkReadyResolve = resolve;
    });

    window.setupEnforcement = (enf: any) => {
      console.log("Arkose SDK Loaded");
      this.enforcement = enf;
      window._arkoseEnforcement = enf;
      this.sdkReadyResolve();
    };
  }

  async getToken(): Promise<string> {
    console.log("Arkose token requested");
    await this.sdkReady;

    this.queue = this.queue.then(() => this.runChallenge());

    return this.queue;
  }

  private runChallenge(): Promise<string> {

    return new Promise((resolve, reject) => {

      const enf = this.enforcement || window._arkoseEnforcement;

      if (!enf) {
        console.error("Arkose SDK not loaded");
        reject(new Error("Arkose SDK not loaded"));
        return;
      }

      enf.setConfig({
        public_key: this.publicKey,

        onCompleted: (response: any) => {
          const token = response?.token;
          console.log("Arkose token generated:", token);
          if (token) {
            resolve(token);
          } else {
            reject(new Error("No Arkose token received"));
          }
        },

        onError: (error: any) => {
          console.error("Arkose error:", error);
          reject(error);
        }
      });
      console.log("Running Arkose challenge");

      enf.run();
    });
  }
}
